import { Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { DiscoverScreen } from './screens/Discover'

/**
 * Public Discover feed — mounted inside album/routes.tsx's `AlbumDesignRoot`,
 * reusing the same app shell as /albums, /galleries, /search, etc.
 *
 * /discover
 */
export const discoverRouteElements = (
  <Route path='discover' element={<AlbumShellLayout />}>
    <Route index element={<DiscoverScreen />} />
  </Route>
)
